import { ISoldeSearchModel } from '../models.interfaces/soldeSearch.model.interface';
export class EmptySoldeSearchModel implements ISoldeSearchModel {
    Annee = null;
    Mois = null;
    SoldeMax = 0;
    CodeTiers = "";
    Actif = null;
}
